export enum ProfileTableNamesEnum {
  NextOfKin = 'NextOfKin',
  CompetenceUser = 'CompetenceUser',
  ReadReceipts = 'ReadReceipts',
  Log = 'Log',
  ExposureLog = 'ExposureLog',
  UserActivitiesTrips = 'UserActivitiesTrips',
}
